import React from 'react';
export function Privacy() {
  return <div className="max-w-3xl mx-auto px-6 pt-32 pb-24" data-id="element-4646">
      <h1 className="text-4xl font-bold text-white mb-8 font-title" data-id="element-4647">
        Privacy Policy
      </h1>

      <div className="space-y-8 text-neutral-300 font-body leading-relaxed" data-id="element-4648">
        <section data-id="element-4649">
          <p data-id="element-4650">
            At Giga, we take your privacy seriously. This Privacy Policy
            explains how we collect, use, disclose, and safeguard your
            information when you visit our website and use our service.
          </p>
        </section>

        <section data-id="element-4651">
          <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-4652">
            1. Information We Collect
          </h2>
          <p className="mb-4" data-id="element-4653">
            We collect information that you provide directly to us when you
            create an account, connect integrations, or communicate with us.
          </p>
        </section>

        <section data-id="element-4654">
          <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-4655">
            2. How We Use Your Information
          </h2>
          <p className="mb-4" data-id="element-4656">
            We use your information to provide, maintain, and improve our
            services, process transactions, and send technical notices.
          </p>
        </section>

        <section data-id="element-4657">
          <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-4658">
            3. Data Security and AI Processing
          </h2>
          <p data-id="element-4659">
            We implement appropriate technical and organizational security
            measures designed to protect the security of any personal
            information we process. When you connect third-party tools, Giga
            acts as a secure proxy. We do not use your private data or chat
            history to train our foundational AI models. Your data remains
            yours.
          </p>
        </section>

        <section data-id="element-4660">
          <h2 className="text-2xl font-semibold text-white mb-4" data-id="element-4661">
            4. Contact Us
          </h2>
          <p data-id="element-4662">
            If you have questions or comments about this Privacy Policy, please
            contact us at hello@gigabrain.dev.
          </p>
        </section>

        <section data-id="element-4663">
          <p className="text-sm text-neutral-500 mt-12" data-id="element-4664">
            Last updated: May 2026
          </p>
        </section>
      </div>
    </div>;
}